import { useEffect } from 'react';
import { useEventTracker } from '@increasecard/increase-core';
import { useLocation } from 'react-router-dom';
export function RouteChangeTracker() {
  const tracker = useEventTracker();
  const location = useLocation();

  useEffect(() => {
    let eventName: string;
    switch (location.pathname) {
      case '/dashboard':
        eventName = 'View Dashboard Page';
        break;
      case '/chargebacks':
        eventName = 'View Chargebacks Page';
        break;
      case '/clearings':
        eventName = 'View Payments Page';
        break;
      case '/clearings/upload':
        eventName = 'View Clearing Manual Upload Page';
        break;
      case '/operations':
        eventName = 'View Movements Page';
        break;
      case '/reports':
        eventName = 'View Reports Page';
        break;
      case '/settings':
        eventName = 'View Settings Credentials Page';
        break;
      case '/settings/users':
        eventName = 'View Settings Users Page';
        break;
      case '/taxations':
        eventName = 'View Taxations Page';
        break;
      default:
        eventName = `View ${location.pathname} Page`;
    }
    tracker.track(eventName, { path: location.pathname, fullURL: window.location.toString() });
  }, [tracker, location]);
  return null;
}
